
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import vClickOutside from 'v-click-outside';
import InlineSvg from 'vue-inline-svg';
import Donut from 'vue-css-donut-chart';
import VueProgressBar from '@/plugins/progressbar';
import Toasted from '@/plugins/toasted';
import Dialog from '@/plugins/dialog';

import App from './App.vue';
import router from './router';
import i18n from './i18n';
import ErrorFilter from './common/error.filter';
import ProgressDonut from './views/ProgressDonut.vue';

import 'vue-css-donut-chart/dist/vcdonut.css';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/bootstrap-compat.scss';
import './assets/scss/style.scss';
import './assets/scss/override.scss';

import { SsoService } from './common/api.service';

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

// Plugins
const progressBarOptions = {
  color: '#2C7BAE',
  failedColor: '#fd397a',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
};
app.use(VueProgressBar, progressBarOptions);

// @ts-ignore
app.use(Toasted, {
  position: 'top-center',
  className: 'alert',
  duration: 2000,
});
app.use(Dialog);
app.use(Donut);
app.use(vClickOutside);

// Global components
app.component('ProgressDonut', ProgressDonut);
app.component('inline-svg', InlineSvg);

// Global properties (replacing filters)
app.config.globalProperties.$filters = {
  error: ErrorFilter,
  str_limit: (value, size) => {
    if (!value) return '';
    const text = value.toString();
    if (text.length <= size) {
      return text;
    }
    return `${text.substr(0, size)}[...]`;
  },
};

SsoService.init();

app.mount('#app');
